import React from 'react';
import { STitle } from './ChangePasswordPage.styles';
import { ChangePasswordForm } from './ChangePasswordForm/ChangePasswordForm';
import { useChangePasswordMutation } from 'store/forgotPassword/forgotPassword.api';

export const ChangePasswordPage: React.FC = () => {
  const [changePassword, { isLoading }] = useChangePasswordMutation();

  return (
    <>
      <STitle>Forgot password</STitle>
      <ChangePasswordForm handleChangePassword={changePassword} isLoading={isLoading} />
    </>
  );
}; 